import React from "react";
import SectionTitle from "../../components/SectionTitle";
import WithHelmet from "../../utils/WithHelmet";

// meta tags
const pageTitle = " Read Latest Blogs | Md Shahar Shitol";
const description =
  "Stay updated with the latest insights and trends in web development. Check out our engaging blogs written by Md Shahar Shitol, covering various topics related to frontend and backend development, best practices, and industry news.";
const keywords = [
  "blogs",
  "web development",
  "frontend development",
  "backend development",
  "industry news",
  "md shahar shitol",
  "frontend developer",
  "hire me",
];
const Blog = () => {
  return (
    <div
      className="md:p-10 p-3 py-10 mb-16  mx-auto"
      data-aos="fade-right"
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="700"
      data-aos-easing="ease-in-out"
    >
      <SectionTitle>Blog</SectionTitle>
      <h1 className="mt-7">Coming Soon.....</h1>
    </div>
  );
};

export default WithHelmet(Blog, pageTitle, description, keywords);
